// src/modules/estimates/rates/hooks/useResourceRates.ts
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { resourceRatesService } from '../services/resourceRates.service';
import { ResourceRate } from '../types';
import { toast } from 'sonner';

export const useResourceRates = (type?: string) => {
  const queryClient = useQueryClient();

  // Query: Get list of resources
  const resourcesQuery = useQuery({
    queryKey: ['resource-rates', type],
    queryFn: () => resourceRatesService.getResources(type),
  });

  // Mutation: Update rate
  const updateRateMutation = useMutation({
    mutationFn: (rate: Partial<ResourceRate>) => resourceRatesService.updateRate(rate),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['resource-rates'] });
      toast.success('Cập nhật đơn giá thành công');
    },
    onError: (error: any) => {
      toast.error('Lỗi khi cập nhật đơn giá: ' + error.message);
    }
  });

  return {
    resources: resourcesQuery.data || [],
    isLoading: resourcesQuery.isLoading,
    isError: resourcesQuery.isError,
    updateRate: updateRateMutation.mutate,
    isUpdating: updateRateMutation.isPending
  };
};

export const useResourceStats = () => {
  return useQuery({
    queryKey: ['resource-stats'],
    queryFn: () => resourceRatesService.getStats()
  });
};

export const useResourceDetail = (id: string) => {
  return useQuery({
    queryKey: ['resource-detail', id],
    queryFn: () => resourceRatesService.getResourceDetail(id),
    enabled: !!id
  });
};

export const useResourceCategories = (type?: string) => {
  return useQuery({
    queryKey: ['resource-categories', type],
    queryFn: () => resourceRatesService.getCategories(type)
  });
};

export const useResourceUnits = () => {
  return useQuery({
    queryKey: ['resource-units'],
    queryFn: () => resourceRatesService.getUnits()
  });
};
